export const formatDateOfBirth = (date: string, locale: string) =>
  new Date(date).toLocaleDateString(locale)

export const isValidDate = (date: string) => /\d/.test(date)
